var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.display)?_c('ul',{class:_vm.className},_vm._l((_vm.dots),function(dot){return _c('li',{key:dot},[(dot < _vm.index)?_c('div',{staticClass:"dot complete"}):_c('div',{staticClass:"dot incomplete"})])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }